export const recordActionPopups = {
  ACTIONS: 'ACTIONS',
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
};

export const invitationTypes = {
  SPOC: 'SPOC',
  TEAM_LEAD: 'TEAM_LEAD',
  MEMBER: 'MEMBER'
};

export const licenceTypes = {
  ESSENTIAL: 'ESSENTIAL',
  PLUS: 'PLUS',
  ADVANCED: 'ADVANCED',
  ORGANISATION: 'ORGANISATION',
  FRIEND: 'FRIEND',
  FRIENDS_WITH_BENEFITS: 'FRIENDS_WITH_BENEFITS',
  PARTNER: 'PARTNER'
};

export const licenceCreditsMapping = {
  [licenceTypes.ESSENTIAL]: 10,
  [licenceTypes.PLUS]: 40,
  [licenceTypes.ADVANCED]: 120,
  [licenceTypes.ORGANISATION]: 1000,
  [licenceTypes.FRIEND]: 10,
  [licenceTypes.FRIENDS_WITH_BENEFITS]: 40,
  [licenceTypes.PARTNER]: 40
};

export const AccountManagementAddEditPopupTabs = {
  BASIC_SETTINGS: 'BASIC_SETTINGS',
  ACCESS_TO_COMMUNITY: 'ACCESS_TO_COMMUNITY',
  ACCESS_TO_TECHNOLOGY: 'ACCESS_TO_TECHNOLOGY'
};
